import { defineNuxtPlugin } from '#app'
import Form from '@primevue/forms/form'
import FormField from '@primevue/forms/formfield'

export default defineNuxtPlugin((nuxtApp) => {
  // Verificar si los componentes ya están registrados antes de registrarlos
  if (!nuxtApp.vueApp._context.components.Form) {
    nuxtApp.vueApp.component('Form', Form)
  }
  if (!nuxtApp.vueApp._context.components.FormField) {
    nuxtApp.vueApp.component('FormField', FormField)
  }
})
